import assetAdvancedFilters from '../modals/advancedFilters/lan/en';
import createEditAsset from '../modals/createEditAsset/lan/en';
import deleteAsset from '../modals/deleteAsset/lan/en';

export default {
    manage_asset_unit: "Unit",
    manage_asset_assetType: "Asset Type",
    manage_asset_assetSubType: "Asset Subtype",
    manage_asset_externalID: "External ID",
    manage_asset_vin: "VIN",
    manage_asset_label: "Label",
    manage_asset_inspectionDeviceType: "Inspection Device Type",
    manage_asset_tags: "Tags",
    manage_asset_status: "Status",
    manage_asset_active: "Active",
    manage_asset_inactive: "Inactive",
    manage_asset_search_table: "Search by Label, VIN, Asset Type and Asset Subtype",
    ...assetAdvancedFilters,
    ...createEditAsset,
    ...deleteAsset,
}